import style from "./Checkbox.module.scss";
import cn from "classnames";

export function Checkbox({
    checked,
    onChange
}: {
    checked: boolean,
    onChange: () => void
}) {
    return (
        <div  
            className={cn(
                style.container,
                checked && style.checked
            )}
            onClick={onChange}
        >
            <input type="checkbox" onChange={() => {}} checked={checked} className="hidden" />
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.8105 0.727521C11.0632 1.03089 11.0632 1.52274 10.8105 1.82611L4.79743 9.04495C4.29205 9.65172 3.47266 9.65164 2.96728 9.04495L0.189517 5.71017C-0.0631724 5.40682 -0.0631724 4.91494 0.189517 4.6116C0.442214 4.30825 0.851906 4.30825 1.1046 4.6116L3.88236 7.94638L9.89542 0.727521C10.1481 0.42416 10.5578 0.42416 10.8105 0.727521Z" fill="#183551" />
            </svg>
        </div>
    )
}